import {createFileRoute} from '@tanstack/react-router';
import {StatementOBPaymentStatusPage} from 'pages/statements/StatementPaymentStatusPage/StatementOBPaymentStatusPage';

export const Route = createFileRoute(
  '/_protected/home/statements/$id/open-banking',
)({
  component: StatementOBPaymentStatusPage,
  staticData: {crumbKey: 'navigation.statement.payment'},
});
